import type { Message } from '../../../i18n/types';

/** Texts of the scheduled full run: «Автоматизация» → «⋯» → «Расписание». */
export const automationScheduleEn = {
  'automation.schedule.open': 'Schedule',
  'automation.schedule.title': 'Scheduled full run',
  'automation.schedule.hint':
    'TMS starts every project by itself — the same as the «Full run» button — so results stay fresh between pushes. Each project may have its own time. Time is Almaty.',
  'automation.schedule.enabled': 'Start a full run on schedule',
  'automation.schedule.time': 'Common time (Almaty)',
  'automation.schedule.days': 'Days',
  'automation.schedule.day.1': 'Mon',
  'automation.schedule.day.2': 'Tue',
  'automation.schedule.day.3': 'Wed',
  'automation.schedule.day.4': 'Thu',
  'automation.schedule.day.5': 'Fri',
  'automation.schedule.day.6': 'Sat',
  'automation.schedule.day.7': 'Sun',
  'automation.schedule.scope': 'All automation projects, environment {environment}.',
  'automation.schedule.scopeSome': {
    one: '{count} chosen project, environment {environment}.',
    other: '{count} chosen projects, environment {environment}.',
  },
  'automation.schedule.projects': 'Projects and start times',
  'automation.schedule.projectsHint':
    'Projects that share a test account must not start together: the second login within a minute gets «SMS code already sent», and that run cannot log in. A scheduled run cannot take accounts from the TestRun pool — the server has no browser to reach it. A project without its own time starts at the common one.',
  'automation.schedule.step': 'Step, min',
  'automation.schedule.spread': 'Spread out',
  'automation.schedule.include': 'Run {name} on schedule',
  'automation.schedule.projectTime': 'Start of {name}',
  'automation.schedule.together': 'Starting together at {time}: {names}',
  'automation.schedule.noProjects': 'No project is chosen — nothing will start.',
  'automation.schedule.next': 'Next start: {when}',
  'automation.schedule.dueNow': 'Starting — within a minute.',
  'automation.schedule.off': 'The schedule is off.',
  'automation.schedule.noDays': 'No day is chosen — nothing will start.',
  'automation.schedule.last': 'Last scheduled start: {date}',
  'automation.schedule.openLast': 'open the full run',
  'automation.schedule.saved': 'Schedule saved',
  'automation.schedule.catchUp':
    'If TMS is down at that time, the run starts when it is back, but no later than two hours after.',
} satisfies Record<string, Message>;

export const automationScheduleRu: Record<keyof typeof automationScheduleEn, Message> = {
  'automation.schedule.open': 'Расписание',
  'automation.schedule.title': 'Полный прогон по расписанию',
  'automation.schedule.hint':
    'TMS сама запускает все проекты — как кнопка «Полный прогон», — чтобы результаты не устаревали между пушами. У каждого проекта может быть своё время. Время — Алматы.',
  'automation.schedule.enabled': 'Запускать полный прогон по расписанию',
  'automation.schedule.time': 'Общее время (Алматы)',
  'automation.schedule.days': 'Дни',
  'automation.schedule.day.1': 'Пн',
  'automation.schedule.day.2': 'Вт',
  'automation.schedule.day.3': 'Ср',
  'automation.schedule.day.4': 'Чт',
  'automation.schedule.day.5': 'Пт',
  'automation.schedule.day.6': 'Сб',
  'automation.schedule.day.7': 'Вс',
  'automation.schedule.scope': 'Все проекты автоматизации, окружение {environment}.',
  'automation.schedule.scopeSome': {
    one: 'Выбран {count} проект, окружение {environment}.',
    few: 'Выбрано {count} проекта, окружение {environment}.',
    many: 'Выбрано {count} проектов, окружение {environment}.',
    other: 'Выбрано {count} проекта, окружение {environment}.',
  },
  'automation.schedule.projects': 'Проекты и время старта',
  'automation.schedule.projectsHint':
    'Проекты с общим тестовым аккаунтом не запускайте вместе: второй вход в ту же минуту получает «SMS код уже отправлен», и его прогон не войдёт. Аккаунты из пула TestRun расписанию недоступны — у сервера нет браузера, чтобы до него дойти. Проект без своего времени стартует в общее.',
  'automation.schedule.step': 'Шаг, мин',
  'automation.schedule.spread': 'Развести по времени',
  'automation.schedule.include': 'Запускать {name} по расписанию',
  'automation.schedule.projectTime': 'Старт {name}',
  'automation.schedule.together': 'Вместе в {time}: {names}',
  'automation.schedule.noProjects': 'Не выбран ни один проект — ничего не запустится.',
  'automation.schedule.next': 'Следующий запуск: {when}',
  'automation.schedule.dueNow': 'Запускается — в течение минуты.',
  'automation.schedule.off': 'Расписание выключено.',
  'automation.schedule.noDays': 'Не выбран ни один день — ничего не запустится.',
  'automation.schedule.last': 'Последний запуск по расписанию: {date}',
  'automation.schedule.openLast': 'открыть полный прогон',
  'automation.schedule.saved': 'Расписание сохранено',
  'automation.schedule.catchUp':
    'Если в это время TMS недоступна, прогон начнётся, когда она поднимется, но не позже чем через два часа.',
};
